/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {LibraryCreativeCopyModalComponent, LibraryCreativeCopyModalResult} from './library-creative-copy-modal.component';

export interface LibraryCreativeCopyModalOptions {
  model: any;
  onComplete?: (result: LibraryCreativeCopyModalResult) => void;
}

@Injectable({providedIn: 'root'})
export class LibraryCreativeCopyModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(options: LibraryCreativeCopyModalOptions): void {
    this.angularModalService.show(LibraryCreativeCopyModalComponent, {
      initialState: options
    });
  }
}
